import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Flex,
  Form,
  Layout,
  message,
  Modal,
  Progress,
  TableColumnsType,
  TableProps,
  Tabs,
  TabsProps,
  Tooltip,
  Typography,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import PageHeader from "../../../components/page-header/PageHeader";
import TableData from "../../../components/table-data/TableData";
import {
  exportStudentFile,
  getRegisterStudentList,
  moocStudentManagementCountStudent,
  removeStudentFromCourse,
} from "../../../service/course-management";
import CertificateModal from "./components/certificate-modal/CertificateModal";
import "./CourseStudentList.scss";
import { getCourseName } from "../../../service/courses";
import { routesConfig } from "../../../config/routes";
import FilterStudentList from "./filter-table/FilterTable";
import FormFilter from "./filter-table/FormFilter";
import { postEnrolledClass } from "../../../service/course-construct";
import { title } from "process";
import classNames from "classnames";
import { handleExportExcel } from "../../../utils/functionUltils";

type Props = {};

const CourseStudentList = (props: Props) => {
  const { t } = useTranslation();
  const { courseId } = useParams();
  const [detailData, setDetailData] = useState<any>(null);

  useEffect(() => {
    const getDetailCourseData = async () => {
      try {
        await getCourseName(Number(courseId)).then((res) => {
          const { data } = res.data;
          setDetailData(data);
        });
      } catch (error) {}
    };
    getDetailCourseData();
  }, [courseId]);

  const navigate = useNavigate();
  const [tab, setTab] = useState("0");
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [courseStudentList, setCourseStudentList] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [certificateChoose, setCertificateChoose] = useState<any>();
  const [isViewCertificate, setIsViewCertificate] = useState<boolean>(false);
  const [isScheduleByTeacherCourse, setIsScheduleByTeacherCourse] =
    useState<boolean>(false);
  const [countOfPaidCourse, setCountOfPaidCourse] = useState(0);
  const [countOfPreStudyCourse, setCountOfPreStudyCourse] = useState(0);
  const [countOfTrialCourse, setCountOfTrialCourse] = useState(0);
  const [countOfDeletedCourse, setCountOfDeletedCourse] = useState(0);
  const [enrollClassData, setEnrollClassData] = useState<any>();
  const [loadingExport, setLoadingExport] = useState<boolean>(false);

  const [form] = Form.useForm();

  // Breadcrumb
  const listBreadcrumb = [
    {
      title: t("Quản lý khóa học", "Quản lý khóa học"),
    },
    {
      title: <span>{detailData?.name}</span>,
    },
  ];

  const getRegistrationStatusByTab = (tab: string) => {
    switch (tab) {
      case "0":
        return [];
      case "1":
        return [2];
      case "2":
        return [1];
      case "3":
        return [3];
      case "4":
        return [0];
      default:
        break;
    }
  };

  // Fetch data
  const getListData = async () => {
    setLoading(true);
    const data = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue.trim() || undefined,
      courseId: courseId,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      registrationStatus: !isEmpty(form.getFieldValue("registrationStatus"))
        ? form.getFieldValue("registrationStatus")
        : getRegistrationStatusByTab(tab),
      enrollClass: form.getFieldValue("enrollClass"),
      registerFrom: !isEmpty(form.getFieldValue("enrollmentDate"))
        ? dayjs(form.getFieldValue("enrollmentDate")?.[0])
            .endOf("day")
            .toISOString()
        : undefined,
      registerTo: !isEmpty(form.getFieldValue("enrollmentDate"))
        ? dayjs(form.getFieldValue("enrollmentDate")?.[1])
            .endOf("day")
            .toISOString()
        : undefined,
      startLearnDateFrom: !isEmpty(form.getFieldValue("startDate"))
        ? dayjs(form.getFieldValue("startDate")?.[0]).endOf("day").toISOString()
        : undefined,
      startLearnDateTo: !isEmpty(form.getFieldValue("startDate"))
        ? dayjs(form.getFieldValue("startDate")?.[1]).endOf("day").toISOString()
        : undefined,
      endLearnDateFrom: !isEmpty(form.getFieldValue("endDate"))
        ? dayjs(form.getFieldValue("endDate")?.[0]).endOf("day").toISOString()
        : undefined,
      endLearnDateTo: !isEmpty(form.getFieldValue("endDate"))
        ? dayjs(form.getFieldValue("endDate")?.[1]).endOf("day").toISOString()
        : undefined,
    };

    await getRegisterStudentList(data)
      .then((res) => {
        const { data } = res.data;
        setCourseStudentList(data.content);
        setTotalRecords(data.totalElements);
        setIsScheduleByTeacherCourse(data.isScheduleByTeacherCourse);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Count student
  const countStudent = async () => {
    const data = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue.trim() || undefined,
      courseId: courseId,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      registrationStatus: getRegistrationStatusByTab(tab),
      registerFrom: !isEmpty(form.getFieldValue("enrollmentDate"))
        ? dayjs(form.getFieldValue("enrollmentDate")?.[0])
            .endOf("day")
            .toISOString()
        : undefined,
      registerTo: !isEmpty(form.getFieldValue("enrollmentDate"))
        ? dayjs(form.getFieldValue("enrollmentDate")?.[1])
            .endOf("day")
            .toISOString()
        : undefined,
      startLearnDateFrom: !isEmpty(form.getFieldValue("startDate"))
        ? dayjs(form.getFieldValue("startDate")?.[0]).endOf("day").toISOString()
        : undefined,
      startLearnDateTo: !isEmpty(form.getFieldValue("startDate"))
        ? dayjs(form.getFieldValue("startDate")?.[1]).endOf("day").toISOString()
        : undefined,
      endLearnDateFrom: !isEmpty(form.getFieldValue("endDate"))
        ? dayjs(form.getFieldValue("endDate")?.[0]).endOf("day").toISOString()
        : undefined,
      endLearnDateTo: !isEmpty(form.getFieldValue("endDate"))
        ? dayjs(form.getFieldValue("endDate")?.[1]).endOf("day").toISOString()
        : undefined,
    };

    await moocStudentManagementCountStudent(data).then((res) => {
      const { data } = res.data;
      if (res.status === 200) {
        setCountOfPaidCourse(data.advanceCourse);
        setCountOfPreStudyCourse(data.basicCourse);
        setCountOfTrialCourse(data.trialCourse);
        setCountOfDeletedCourse(data.deletedCourse);
      }
    });
  };

  // get List Enrolled Class
  const getListEnrolledClass = async () => {
    const dataReq = {
      courseId: courseId,
    };
    await postEnrolledClass(dataReq)
      .then((res) => {
        if (res.status === 200) {
          const listData = res.data.content?.map((item: any) => {
            return {
              id: item.id,
              name: item.name,
            };
          });
          setEnrollClassData(listData);
        }
      })
      .catch((err) => console.error(err));
  };

  // Search
  const handleSubmitSearch = () => {
    getListData();
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  // Filter
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const clearFilter = () => {
    setPageNumber(1);
    form.resetFields();
    getListData();
  };

  // Handle detele student
  const handleDeleteStudent = async (id: number) => {
    const dataReq = {
      courseId: Number(courseId),
      studentId: id,
    };
    try {
      const res = await removeStudentFromCourse(dataReq);
      if (res.status === 200) {
        message.success(t("Xóa học viên thành công!", "Xóa học viên thành công!"));
        countStudent();
        getListData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // render registration status
  const renderRegistrationStatus = (value: number) => {
    switch (value) {
      case 0:
        return t("Đã xóa", "Đã xóa");
      case 1:
        return t("Cơ bản", "Cơ bản");
      case 2:
        return t("Nâng cao", "Nâng cao");
      case 3:
        return t("Học thử", "Học thử");
      default:
        break;
    }
  };

  // Data columns
  const dataColumns: TableColumnsType<any> = [
    {
      title: t("Số thứ tự", "Số thứ tự"),
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Học viên", "Học viên"),
      dataIndex: "studentName",
      key: "studentName",
      sorter: true,
      width: 40,
      render: (_: any, record) => {
        return (
          <div className="student-info">
            <Avatar
              className="student-info__avatar"
              size={64}
              src={record.avatar}
            />
            <div className="student-info__name-email">
              <span>{record.studentName}</span>
              <span>{record.studentEmail}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Tiến độ học tập", "Tiến độ học tập"),
      dataIndex: "completedPercentage",
      key: "completedPercentage",
      width: 30,
      render: (_: any, record) => {
        return (
          <div className="p-3">
            <Progress percent={record.completedPercentage} />
            <Typography.Link
              onClick={() => {
                navigate(
                  `${location.pathname}/${routesConfig.learningProgress}/${record.studentId}`
                );
              }}
              className="view-progress"
            >
              {t("Xem", "Xem")}
            </Typography.Link>
          </div>
        );
      },
    },
    {
      title: t("Điểm GPA", "Điểm GPA"),
      dataIndex: "gpa",
      key: "gpa",
      width: 10,
      render: (_: any, record) => {
        return (
          <div>
            <Flex vertical justify="center" align="center">
              {record.gpa}{" "}
              <Typography.Link
                onClick={() => {
                  navigate(
                    `${location.pathname}/${routesConfig.studentGPA}/${record.studentId}`
                  );
                }}
              >
                {t("Xem", "Xem")}
              </Typography.Link>
            </Flex>
          </div>
        );
      },
    },
    {
      title: t("Ngày ghi danh", "Ngày ghi danh"),
      dataIndex: "registerDate",
      key: "registerDate",
      sorter: true,
      width: 20,
      render: (_: any, record) => {
        return (
          <span>
            {record?.registerDate
              ? dayjs(record?.registerDate).format("DD/MM/YYYY")
              : null}
          </span>
        );
      },
    },
    {
      title: t("Ngày bắt đầu", "Ngày bắt đầu"),
      dataIndex: "startLearnDate",
      key: "startLearnDate",
      width: 20,
      render: (_: any, record) => {
        return (
          <span>
            {record?.startLearnDate
              ? dayjs(record?.startLearnDate).format("DD/MM/YYYY")
              : null}
          </span>
        );
      },
    },
    {
      title: t("Ngày kết thúc (dự kiến)", "Ngày kết thúc (dự kiến)"),
      dataIndex: "endLearnDate",
      key: "endLearnDate",
      width: 20,
      render: (_: any, record) => {
        return (
          <span>
            {record?.endLearnDate
              ? dayjs(record?.endLearnDate).format("DD/MM/YYYY")
              : null}
          </span>
        );
      },
    },
    ...(tab === "2"
      ? [
          {
            title: (
              <div className="conversion-title">
                <span className="mr-2">{t("Ngày chuyển đổi", "Ngày chuyển đổi")}</span>
                <Tooltip title={t("Thời gian học viên chuyển đổi loại ghi danh khoá học", "Thời gian học viên chuyển đổi loại ghi danh khoá học")}>
                  <ExclamationCircleOutlined />
                </Tooltip>
              </div>
            ),
            dataIndex: "conversionDate",
            key: "conversionDate",
            width: 20,
            render: (_: any, record: any) => {
              return (
                <span>
                  {record?.startDate
                    ? dayjs(record?.startDate).format("DD/MM/YYYY")
                    : null}
                </span>
              );
            },
          },
        ]
      : []),
    ...(isScheduleByTeacherCourse
      ? [
          {
            title: t("Lớp ghi danh", "Lớp ghi danh"),
            dataIndex: "enrollClassName",
            key: "enrollClassName",
            width: 20,
          },
        ]
      : []),
    ...(tab === "0"
      ? [
          {
            title: t("Loại ghi danh", "Loại ghi danh"),
            dataIndex: "registrationStatus",
            key: "registrationStatus",
            width: 20,
            render: (_: any, record: any) => {
              return (
                <span>
                  {renderRegistrationStatus(record.registrationStatus)}
                </span>
              );
            },
          },
        ]
      : []),
    ...(tab === "4"
      ? [
          {
            title: t("Ngày xóa", "Ngày xóa"),
            dataIndex: "deletedDate",
            key: "deletedDate",
            width: 20,
            render: (_: any, record: any) => {
              return (
                <span>
                  {record?.deletedDate
                    ? dayjs(record?.deletedDate).format("DD/MM/YYYY")
                    : null}
                </span>
              );
            },
          },
        ]
      : []),
    {
      title: t("Chứng nhận", "Chứng nhận"),
      dataIndex: "certification",
      key: "certification",
      width: 15,
      render: (_: any, record) => {
        return record.isGetCertificate ? (
          <Button
            onClick={() => {
              setIsViewCertificate(true), setCertificateChoose(record);
            }}
          >
            <EyeOutlined />
          </Button>
        ) : null;
      },
    },
    ...(tab !== "4"
      ? [
          {
            title: "",
            dataIndex: "",
            key: "detele",
            width: 8,
            className: "delete-student-col",
            render: (_: any, record: any) => {
              return (
                <span
                  className="detete-button"
                  onClick={() =>
                    Modal.confirm({
                      title: `Xoá học viên`,
                      content: `Bạn có chắc chắn muốn xoá học viên ${record?.studentName} ?`,
                      onOk: () => handleDeleteStudent(record?.studentId),
                      centered: true,
                      okText: t("Xác nhận", "Xác nhận"),
                      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                      footer: (_, { OkBtn, CancelBtn }) => (
                        <>
                          <CancelBtn />
                          <OkBtn />
                        </>
                      ),
                    })
                  }
                >
                  {record.registrationStatus !== 0 ? t("Xóa", "Xóa") : null}
                </span>
              );
            },
          },
        ]
      : []),
  ];

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // Tab's items
  const itemsTab: TabsProps["items"] = [
    {
      key: "0",
      label: <div>{t("Tất cả", "Tất cả")}</div>,
      children: (
        <div className="all-course">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseStudentList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={false}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
          />
        </div>
      ),
    },
    {
      key: "1",
      label: <div>{t("Nâng cao", "Nâng cao")} ({countOfPaidCourse})</div>,
      children: (
        <div className="paid-course">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseStudentList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={false}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: <div>{t("Cơ bản", "Cơ bản")} ({countOfPreStudyCourse})</div>,
      children: (
        <div className="pre-study-course">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseStudentList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={false}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
          />
        </div>
      ),
    },
    {
      key: "3",
      label: <div>{t("Học thử", "Học thử")} ({countOfTrialCourse})</div>,
      children: (
        <div className="trial-course">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseStudentList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={false}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
          />
        </div>
      ),
    },
    {
      key: "4",
      label: <div>{t("Đã xóa", "Đã xóa")} ({countOfDeletedCourse})</div>,
      children: (
        <div className="deleted-students">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseStudentList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={false}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
          />
        </div>
      ),
    },
  ];

  // Handle change tab
  const onChange = (key: string) => {
    setTab(key);
    setPageNumber(1);
    form.resetFields();
  };

  // handle Export
  const handleExportFile = async () => {
    try {
      setLoadingExport(true);
      const res = await exportStudentFile({
        keyword: searchValue.trim() || undefined,
        courseId: courseId,
        sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
        registrationStatus: !isEmpty(form.getFieldValue("registrationStatus"))
          ? form.getFieldValue("registrationStatus")
          : getRegistrationStatusByTab(tab),
        enrollClass: form.getFieldValue("enrollClass"),
        registerFrom: !isEmpty(form.getFieldValue("enrollmentDate"))
          ? dayjs(form.getFieldValue("enrollmentDate")?.[0])
              .endOf("day")
              .toISOString()
          : undefined,
        registerTo: !isEmpty(form.getFieldValue("enrollmentDate"))
          ? dayjs(form.getFieldValue("enrollmentDate")?.[1])
              .endOf("day")
              .toISOString()
          : undefined,
        startLearnDateFrom: !isEmpty(form.getFieldValue("startDate"))
          ? dayjs(form.getFieldValue("startDate")?.[0])
              .endOf("day")
              .toISOString()
          : undefined,
        startLearnDateTo: !isEmpty(form.getFieldValue("startDate"))
          ? dayjs(form.getFieldValue("startDate")?.[1])
              .endOf("day")
              .toISOString()
          : undefined,
        endLearnDateFrom: !isEmpty(form.getFieldValue("endDate"))
          ? dayjs(form.getFieldValue("endDate")?.[0]).endOf("day").toISOString()
          : undefined,
        endLearnDateTo: !isEmpty(form.getFieldValue("endDate"))
          ? dayjs(form.getFieldValue("endDate")?.[1]).endOf("day").toISOString()
          : undefined,
      });
      handleExportExcel(res.data, `${courseId}_Bangdiem_${dayjs().format('DD-MM-YYYY')}.xlsx`);
    } catch (error) {
      console.error("Error exporting file:", error);
    } finally {
      setLoadingExport(false);
    }
  };

  // useEffect
  useEffect(() => {
    getListData();
    countStudent();
  }, [tab, pageNumber, pageSize, statusOrder]);

  useEffect(() => {
    if (isScheduleByTeacherCourse) {
      getListEnrolledClass();
    }
  }, [courseId, isScheduleByTeacherCourse]);

  useEffect(() => {
    const getDetailCourseData = async () => {
      try {
        await getCourseName(Number(courseId)).then((res) => {
          const { data } = res.data;
          setDetailData(data);
        });
      } catch (error) {}
    };
    getDetailCourseData();
  }, [courseId]);

  return (
    <Layout className="page-header-group course-student-list">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "filterForm") {
            getListData();
          }
        }}
      >
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper justify-between pb-6">
            <div className="table-header--left">
              <PageHeader
                title={t("Danh sách học viên", "Danh sách học viên")}
                listBreadcrumb={listBreadcrumb}
                breadcrumb={true}
              />
            </div>
            <FilterStudentList
              searchValue={searchValue}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              handleChangeInput={handleChangeInput}
              tab={tab}
              onExport={handleExportFile}
            />
          </div>

          {showFilter ? (
            <FormFilter
              handleCloseFilter={handleCloseFilter}
              clearFilter={clearFilter}
              form={form}
              showFilter={showFilter}
              tab={tab}
              isScheduleByTeacherCourse={isScheduleByTeacherCourse}
              enrollClassData={enrollClassData}
            />
          ) : null}
        </div>
        <div className="tabs-heading">
          <div className="course-student-list">
            <Tabs items={itemsTab} activeKey={tab} onChange={onChange} />
          </div>
        </div>
      </Form.Provider>
      <CertificateModal
        studentId={certificateChoose?.studentId}
        open={isViewCertificate}
        handleCancel={() => setIsViewCertificate(false)}
      />
    </Layout>
  );
};

export default CourseStudentList;
